export default __webpack_public_path__ + "static/media/abdurakhmon.2ddd5830.jpg";